<template>
  <span
    class="-mx-2 inline-block cursor-pointer whitespace-nowrap rounded-md px-2 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-100 active:bg-gray-200"
  >
    <slot></slot>
  </span>
</template>
